import React from "react";
import { ScheduleComparisonHeader, ScheduleComparisonActions } from "./ScheduleComparisonChrome";

import AutoScheduleDiffs from "./AutoScheduleDiffs";
import BoundaryStaffingNotice from "./BoundaryStaffingNotice";

function AutoScheduleComparison(props) {
  const boundary = props.schedule_differences?.boundary_staffing;
  const schedDif = props.schedule_differences?.sched_dif || [];

  return (
    <div className="flex h-full min-h-0 w-full flex-col overflow-hidden">
      <ScheduleComparisonHeader id="schedule-comparison-title" runLabel="Autoschedule" weekStart={props.week_start_date}
        onClose={props.handleClose} busy={props.acceptedLoading} />
      <div className="min-h-0 flex-1 overflow-y-auto px-5 py-3 sm:px-3">
        {boundary?.status === "search_unresolved" && <BoundaryStaffingNotice boundary={boundary} />}
        {props.schedule_differences ? (
          <AutoScheduleDiffs
            sched_dif={schedDif}
            calcLetter={props.calcLetter}
            schedule_differences={props.schedule_differences}
            cancelAndClose={props.cancelAndClose}
            acceptedLoading={props.acceptedLoading}
            saveAndClose={props.saveAndClose}
            store_team_member_weekly_info={props.store_team_member_weekly_info}
            get_t_str={props.get_t_str}
            actual_schedule={props.schedule_differences?.actual_schedule || props.actual_schedule}
            actual_schedule_labor={props.schedule_differences?.actual_schedule_labor || props.actual_schedule_labor}
            forecasted_labor={props.schedule_differences?.forecasted_labor || props.forecasted_labor}
            grade_weights={props.grade_weights}
            role_types={props.role_types}
            role_names={props.role_names}
            week_start_date={props.week_start_date}
            storeNames={props.storeNames}
            store_id={props.store_id}
          />
        ) : (
          <div className="flex justify-center items-center mt-72">
            <div className="text-xl text-violet-700">
              No opportunities identified by autoscheduler.
            </div>
          </div>
        )}
      </div>
      <ScheduleComparisonActions onCancel={props.cancelAndClose || props.handleClose}
        busy={props.acceptedLoading} disabled={!schedDif.length}
        onApply={() => props.saveAndClose(schedDif.map((day) => ({ ...day, status: "accepted" })))} />
    </div>
  );
}

export default AutoScheduleComparison;
